(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('katharos-review-slideshow')) {
    customElements.define(
      'katharos-review-slideshow',
      class extends HTMLElement {
        connectedCallback() {
          if (this.controller) return;

          this.slides = Array.from(
            this.querySelectorAll('.kr-review-track > .review-card')
          );

          if (!this.slides.length) return;

          this.controller = new AbortController();
          const signal = this.controller.signal;

          this.dots = Array.from(
            this.querySelectorAll('[data-review-index]')
          );

          this.controls = this.querySelector('.kr-controls');
          this.status = this.querySelector('.kr-status');

          if (this.controls) {
            this.controls.hidden = false;
          }

          this.addEventListener(
            'click',
            (event) => {
              const button = event.target.closest('button');

              if (!button || !this.contains(button)) return;

              if (button.hasAttribute('data-review-prev')) {
                this.showSlide(this.index - 1);
              } else if (button.hasAttribute('data-review-next')) {
                this.showSlide(this.index + 1);
              } else if (button.hasAttribute('data-review-index')) {
                this.showSlide(Number(button.dataset.reviewIndex));
              }
            },
            { signal }
          );

          // Show the selected review while editing in Shopify.
          this.addEventListener(
            'shopify:block:select',
            (event) => {
              const index = this.slides.findIndex(
                (slide) =>
                  slide === event.target ||
                  slide.contains(event.target)
              );

              if (index !== -1) {
                this.showSlide(index);
              }
            },
            { signal }
          );

          this.showSlide(0, false);
        }

        showSlide(index, announce = true) {
          this.index =
            (index + this.slides.length) % this.slides.length;

          this.slides.forEach((slide, slideIndex) => {
            slide.hidden = slideIndex !== this.index;
          });

          this.dots.forEach((dot, dotIndex) => {
            dot.setAttribute(
              'aria-pressed',
              String(dotIndex === this.index)
            );
          });

          if (this.status && announce) {
            this.status.textContent =
              `Review ${this.index + 1} of ${this.slides.length}`;
          }
        }

        disconnectedCallback() {
          this.controller?.abort();
          this.controller = null;

          this.slides?.forEach((slide) => {
            slide.hidden = false;
          });

          if (this.controls) {
            this.controls.hidden = true;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
